import React from 'react';
import { ParallaxSection } from './ParallaxSection';
export function ReframeSection() {
  return <section className="relative h-[1024px] px-4 flex items-center justify-center overflow-hidden" data-id="element-102">
      <div className="max-w-7xl mx-auto w-full" data-id="element-103">
        <ParallaxSection speed={0.2} data-id="element-104">
          <div className="space-y-8 max-w-4xl mx-auto" data-id="element-105">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight max-w-[280px] md:max-w-[850px] text-left" data-id="element-106">
              What if researchers could find, match and access samples 8x
              faster?
            </h2>
            <p className="text-xl md:text-2xl text-white/80 leading-relaxed text-left max-w-[280px] md:max-w-[800px]" data-id="element-107">
              Not only is it possible, it's happening now, more safe and
              securely than ever.
            </p>
          </div>
        </ParallaxSection>
      </div>
    </section>;
}